import queryString from 'query-string';

import useTranslation from '@/utils/hooks/translation/useTranslation';

// Utils
import useRouterQuery from '@/utils/hooks/utils/useRouterQuery';

// Types
import type { SocialProfileType } from '@/types/socialProfileType';

import { PERMISSIONS } from '@/lib/permissions/socialPermissions';
// Lib
import { OAUTH_NETWORKS } from '@/lib/routes/privateRoutes';

// Components
import Button from '@/components/base/Button';
import Icon from '@/components/base/Icon';
import Tooltip from '@/components/base/Tooltip';

type ButtonUnlockPermissionProps = {
    activeSocialProfile: SocialProfileType;
};

export function ButtonUnlockPermission({ activeSocialProfile }: ButtonUnlockPermissionProps) {
    const { t } = useTranslation('scheduler');
    const { deleteAllQueries } = useRouterQuery();
    const redirectUrl = deleteAllQueries();

    const href = `${
        OAUTH_NETWORKS[activeSocialProfile.social_network_type]
    }?${queryString.stringify(
        {
            redirect_to: encodeURIComponent(redirectUrl),
            permissions: [PERMISSIONS.SCHEDULER]
        },
        { arrayFormat: 'bracket' }
    )}`;

    return (
        <Tooltip content={t('unlock_auto_posting')}>
            <Button
                as="a"
                className="w-12 !min-w-min !px-0"
                variant={'whiteNoBorder'}
                data-testid="unlock-scheduler-permission-button"
                href={href}>
                <Icon icon="autopost-no" />
            </Button>
        </Tooltip>
    );
}
